module.exports = __webpack_public_path__ + "img/GH-corporate-top001sp.795595ee.png";